import React from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import useRegReportHook from "../hooks/useRegReportHook";
import { formatDate } from "../../../../utils/formatDate";

const RegReport = ({ source }) => {
  const { data, loading, error } = useRegReportHook(source);

  const columns = [
    {
      field: "District",
      headerName: "District",
      flex: 1,
    },
    {
      field: "High_School",
      headerName: "High School",
      flex: 1,
    },
    {
      field: "Tartan_Id",
      headerName: "Tartan ID",
      flex: 1,
    },
    {
      field: "SSID",
      headerName: "SSID",
      flex: 1,
    },
    {
      field: "First_Name",
      headerName: "First Name",
      flex: 1,
    },
    {
      field: "Last_Name",
      headerName: "Last Name",
      flex: 1,
    },
    {
      field: "Graduation_Year",
      headerName: "Graduation Year",
      flex: 1,
    },
    {
      field: "Course",
      headerName: "Course",
      flex: 1,
    },
    {
      field: "Course_Start_Date",
      headerName: "Course Start Date",
      flex: 1,
    },
    {
      field: "Course_End_Date",
      headerName: "Course End Date",
      flex: 1,
    },
    {
      field: "Restricted",
      headerName: "Restricted",
      flex: 1,
    },
    {
      field: "Current_Academic_Standing",
      headerName: "Current Academic Standing",
      flex: 1,
    },
    {
      field: "Last_Registration_Date",
      headerName: "Last Registration Date",
      type: "date",
      valueFormatter: (value) => formatDate(value),
      flex: 1,
    },
    {
      field: "Credit_Hour_Count",
      headerName: "Credit Hour Count",
      flex: 1,
    },
    {
      field: "Cumulative_GPA",
      headerName: "Cumulative GPA",
      flex: 1,
    },
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div style={{ height: 600, width: "100%" }}>
      <AppDataGrid
        rows={data || []}
        columns={columns}
        slots={{ toolbar: GridToolbarNoExport }}
        pagination
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  );
};

export default RegReport;
